export default __webpack_public_path__ + "93b4ccc46aeb8f18bee9de8dabb3e8a4.svg";